export function downloadFile (res, fileName) {
    let bstr = window.atob(res.body)
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
    }
    let blob = new Blob([u8arr], { type: res['headers']['Content-Type'][0] })
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
        // 这里就按照chrome等新版浏览器来处理
        let url = URL.createObjectURL(blob)
        let a = document.createElement("a")
        document.body.appendChild(a)
        a.href = url
        a.download = fileName
        a.target = "_blank"
        a.click()
        a.remove()
    }
}

export function downloadFileUrl (res, fileName) {
    let bstr = window.atob(res.body)
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
    }
    let blob = new Blob([u8arr], { type: res['headers']['Content-Type'][0] })
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
        // 这里就按照chrome等新版浏览器来处理
        let url = URL.createObjectURL(blob)
        return url
    }
}